import styled, { css, keyframes } from 'styled-components';
import { loaderTokens } from '../../tokens/components/Loader/tokens';

export const absoluteFullSize = css`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const OverlayLoader = styled.div``;

export const WrapperLoader = styled.div`
  position: relative;
`;

export const LoaderBackdrop = styled.div`
  ${absoluteFullSize}
  background-color: ${loaderTokens.CoreBackgroundDefaultColor};
  opacity: ${loaderTokens.CoreBackgroundDefaultOpacity};
  width: 100%;

  ${({ theme }) =>
    theme.type === 'page' &&
    css`
      display: none;
    `}

  ${({ theme }) =>
    theme.type === 'component' &&
    css`
      background-color: ${loaderTokens.CoreBackgroundComponentColor};
      opacity: ${loaderTokens.CoreBackgroundComponentOpacity};
    `}
`;

export const LoaderBody = styled.div`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  ${({ theme }) =>
    theme.type === 'page' &&
    css`
      clear: both;
      margin-left: auto;
      margin-right: auto;
    `}
`;

const loaderFollow = keyframes`
  to { stroke-dashoffset: 0; }
`;

export const LoaderShapePath = styled.path`
  animation-name: ${loaderFollow};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.64, 0.25, 0.36, 0.75);

  fill: transparent;
  stroke: ${({ theme }) =>
    theme.type === 'overlay' ? loaderTokens.CoreStrokeOverlayColor : loaderTokens.CoreStrokeDefaultColor};
  stroke-dasharray: calc(377px / calc(2 * 2));
  stroke-dashoffset: 377;
  stroke-linecap: round;
  stroke-width: 8;

  &:nth-child(2) {
    animation-delay: calc((1s / 40) * -1);
  }

  &:nth-child(3) {
    animation-delay: calc((1s / 40) * -2);
  }
`;

export const LoaderShape = styled.svg`
  display: block;
  height: 100px;
  width: 100px;

  ${({ theme }) =>
    theme.type === 'page' &&
    css`
      height: 60px;
      width: 60px;
    `}

  ${({ theme }) =>
    theme.type === 'component' &&
    css`
      height: 30px;
      width: 30px;
    `}
`;

/* @internal */
export const StyledLoader = styled.div`
  display: none;

  ${({ theme }) =>
    theme.active &&
    css`
      display: block;
    `}

  ${({ theme }) =>
    theme.type === 'page' &&
    css`
      min-height: 12rem;
    `}

${({ theme }) =>
    theme.type === 'component' &&
    css`
      min-height: 8rem;
    `}

${({ theme }) =>
    theme.type === 'overlay' &&
    css`
      ${absoluteFullSize}
      position: fixed;
      z-index: 1010;
    `}
`;
